import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import {
  documentCategoriesMock,
  documentDetailsMock,
  documentsListMock,
  setBookmarkMock,
  successMock,
} from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { documentPath } from '../../utils/paths';

export default {
  documentsListGet: ({ filters }) => {
    if (shouldUseMock()) {
      return documentsListMock();
    }
    return apiCall(
      `${baseUrl}${documentPath}documents/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  documentDetailsGet: ({ id }) => {
    if (shouldUseMock()) {
      return documentDetailsMock();
    }
    return apiCall(`${baseUrl}${documentPath}documents/${id}/details`, 'GET');
  },
  documentCategoriesGet: () => {
    if (shouldUseMock()) {
      return documentCategoriesMock();
    }
    return apiCall(`${baseUrl}${documentPath}category/list`, 'GET');
  },
  setBookmark: (id, action) => {
    if (shouldUseMock()) {
      return setBookmarkMock();
    }
    return apiCall(`${baseUrl}${documentPath}document/${id}/bookmark`, 'POST', {
      action,
    });
  },
  documentDelete: (id, published) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(`${baseUrl}${documentPath}documents/${id}/delete`, 'POST', {
      published,
    });
  },
};
